import React from 'react';
import Typography from '@material-ui/core/Typography';

const BggErrorState = () => (
  <Typography>
    Your data is being processed, please try again in a moment.
  </Typography>
);

export default BggErrorState;
